// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3Ks3i","left":"StickyBox_left__3MKOR","right":"StickyBox_right__Vx8J4"};